module.exports = __webpack_public_path__ + "static/john-roberts.8fc2ef48.webp";